module.exports = __webpack_public_path__ + "img/brm4.e498670a.jpg";